import React from 'react';
const Checkbox = React.memo((props) => {
    var _a;
    return (React.createElement("div", { className: `${(_a = props.parentClass) !== null && _a !== void 0 ? _a : ""}` }, props.options.map((item) => {
        var _a, _b;
        return (React.createElement("label", { className: `inline-flex items-center text-gray-600 dark:text-gray-400 mr-2 ${(_a = props.optionClass) !== null && _a !== void 0 ? _a : ""}`, key: item.key.toString() },
            React.createElement("input", { type: "checkbox", className: "text-haikan-red form-checkbox focus:border-red-400 focus:outline-none focus:shadow-outline-red", name: props.name, value: item.key, onChange: props.onChange, checked: props.value !== null ? (_b = props.value) === null || _b === void 0 ? void 0 : _b.includes(item.key) : false, disabled: props.disabled }),
            React.createElement("span", { className: "ml-2" }, item.value)));
    })));
});
export default Checkbox;
